module.exports = __webpack_public_path__ + "img/toilet_squat.037deb38.svg";